<section class="content-section notif-page">

  <!-- ── En-tête ─────────────────────────────────────────────────── -->
  <div class="notif-page-header">
    <div>
      <h2 class="notif-page-title">Notifications</h2>
      <span class="text-secondary">
        {{ nombreNonLues > 0 ? nombreNonLues + ' non lue(s)' : 'Tout est à jour' }}
      </span>
    </div>
    <div class="notif-page-actions">
      <button class="notif-action-btn" (click)="marquerToutCommeLu()" [disabled]="nombreNonLues === 0">
        <i class="fal fa-check-double"></i> Tout marquer comme lu
      </button>
      <button class="notif-action-btn notif-action-btn--danger" (click)="viderTout()" [disabled]="toutesNotifications.length === 0">
        <i class="fal fa-trash-alt"></i> Vider l'historique
      </button>
    </div>
  </div>

  <!-- ── Filtres ──────────────────────────────────────────────────── -->
  <div class="notif-tabs">
    <button type="button" class="notif-tab" [class.notif-tab--active]="filtre === 'toutes'" (click)="filtre = 'toutes'">
      Toutes <span class="notif-tab-count">{{ toutesNotifications.length }}</span>
    </button>
    <button type="button" class="notif-tab" [class.notif-tab--active]="filtre === 'nonLues'" (click)="filtre = 'nonLues'">
      Non lues <span class="notif-tab-count" [class.notif-tab-count--active]="nombreNonLues > 0">{{ nombreNonLues }}</span>
    </button>
  </div>

  <!-- ── Liste ────────────────────────────────────────────────────── -->
  <div class="notif-list">
    <div *ngFor="let n of notificationsFiltrees"
         class="notif-card"
         [class.notif-card--unread]="!n.lu"
         [ngClass]="getTypeClass(n.type)"
         (click)="marquerCommeLu(n)">

      <div class="notif-card-icon" [ngClass]="getTypeClass(n.type)">
        <i [class]="n.icone || 'fal fa-bell'"></i>
      </div>

      <div class="notif-card-body">
        <div class="notif-card-top">
          <h4 class="notif-card-title">{{ n.titre }}</h4>
          <div class="notif-card-meta">
            <span class="notif-card-time">{{ formatTemps(n.dateCreation) }}</span>
            <span class="notif-unread-dot" *ngIf="!n.lu"></span>
          </div>
        </div>
        <p class="notif-card-message">{{ n.message }}</p>
      </div>

      <button class="notif-del-btn"
              (click)="supprimerNotification(n); $event.stopPropagation()"
              title="Supprimer">
        <i class="fal fa-times"></i>
      </button>
    </div>

    <!-- Vide -->
    <div *ngIf="notificationsFiltrees.length === 0" class="notif-empty">
      <div class="notif-empty-icon">
        <i class="fal fa-bell-slash"></i>
      </div>
      <h3>Aucune notification</h3>
      <p>{{ filtre === 'nonLues' ? 'Toutes vos notifications ont été lues' : 'Vous n\'avez aucune notification pour le moment' }}</p>
    </div>
  </div>

</section>
